<template>
  <b-card>
    <b-row class="px-1 align-items-center justify-content-between">
      <h5> الغعاليات المُشارك بها خارج القطر </h5>
    </b-row>
    <hr />
    <data-table
      ep="v2/I-events-subscriptions"
      id="IEventsSubscriptions"
      :fields="tableFields"
      ref="IEventsSubscriptionsTable"
      @row-clicked="onRowClicked"
    >
      <template #cell(invitation_file)="{ value }" >
        <b-button
          size="sm"
          @click="$router.push({ name: 'file-view', query: { ep: value } })"
          variant="flat-success"
        >
          <feather-icon class="mx-25" icon="EyeIcon" />
          عرض الملف
        </b-button>
      </template>
      <template #cell(actions)="row">
        <div class="d-flex justify-content-end">
          
          <b-button
            variant="flat-info"
            @click="row.toggleDetails"
            title="عرض المزيد من المعلومات"
            size="sm"
            class="btn-icon rounded-circle"
            v-b-tooltip.hover.v-info.top
          >
            <feather-icon icon="InfoIcon" size="1.8x" color="#82868b" />
          </b-button>
        </div>
      </template>
      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col md="12" class="mb-1 d-flex">
              <strong> العنوان </strong>
              <div class="text-info mx-1" v-html="row.item.address"></div>
            </b-col>
            <b-col md="12" class="mb-1 d-flex">
              <strong> الهدف من الفعالية</strong>
              <div class="text-info mx-1" v-html="row.item.objective"></div>
            </b-col>
            <b-col md="12" class="mb-1 d-flex">
              <strong> الجهات الإخرى المدعوة للفعالية </strong>
              <div class="text-info mx-1" v-html="row.item.other_invited_parties"></div>
            </b-col>
          </b-row>

          <b-button
            size="sm"
            variant="outline-secondary"
            @click="row.toggleDetails"
          >
            عرض اقل
          </b-button>
        </b-card>
      </template>
    </data-table>
  </b-card>
</template>

<script>
import { BCard, BRow, BButton , VBTooltip ,BCol} from "bootstrap-vue";
import DataTable from "@/components/data-table";
import { mapGetters, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCard,
    BRow,
    DataTable,
    BButton,
    VBTooltip,
    BCol
  },
  data() {
    return {
      tableFields: [
        { key: "id", label: "المعرف" },
        { key: "event_type", label: "نوع الغعالية" },
        { key: "start_date", label: "تاريخ بدء الفعالية" },
        { key: "end_date", label: "تاريخ نهاية الغعالية" },
        { key: "organiser", label: "الجهة المنظمة للفعالية" },
        { key: "country.name", label: "الدولة" },
        { key: "invitation_file", label: "صورة عن الدعوة" },
        { key: "actions", label: " " },
      ],
    };
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  methods: {
    ...mapActions("UNCoop", ["deleteProject"]),
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف مشروع التعاون", {
          title: "تأكيد الحذف",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteProject(id).then(() => {
              this.$refs.IEventsSubscriptionsTable.refreshTable();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تم حذف المشروع بنجاح ",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            });
          }
        });
    },
    onRowClicked(val) {
      this.$router.push(`/un-coop/projects/${val.id}`);
    },
  },
  computed: {
    ...mapGetters("UNCoop", ["working"]),
  },
};
</script>
